import { QRScanner } from "@/components/agent/QRScanner";
import { PageHeader } from "@/components/shared";

export default function QRScanPage() {
  return (
    <div className="max-w-md mx-auto px-4 py-8">
      <PageHeader
        title="Unlock Seller Contact"
        subtitle="Scan the QR code shown by the property owner"
      />
      <QRScanner />
    </div>
  );
}
